var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpresa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.68 27.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,27.68V6.34H6.34V0h15V12.69h6.34v15H15.88v-6.34h-4.08v6.34H0Zm2.31-2.31H6.34v-4.04H2.31v4.04Zm0-6.34H6.34v-4.04H2.31v4.04Zm0-6.34H6.34v-4.04H2.31v4.04Zm6.34,6.34h4.04v-4.04h-4.04v4.04Zm0-6.34h4.04v-4.04h-4.04v4.04Zm0-6.34h4.04V2.31h-4.04V6.34Zm6.34,12.69h4.04v-4.04h-4.04v4.04Zm0-6.34h4.04v-4.04h-4.04v4.04Zm0-6.34h4.04V2.31h-4.04V6.34Zm6.34,19.03h4.04v-4.04h-4.04v4.04Zm0-6.34h4.04v-4.04h-4.04v4.04Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresa);
export default __webpack_public_path__ + "static/media/empresa.20cbd9262ae5f4212ded0e35dd9752be.svg";
export { ForwardRef as ReactComponent };